import React from 'react';
export const ExploreViewContext = React.createContext(null);
export const useExploreViewContext = () => React.useContext(ExploreViewContext);
